import { useQuery } from "@apollo/client";
import { loader } from "graphql.macro";
import React from "react";
import { useParams } from "react-router-dom";
import SearchLoader from "./Loaders/SearchLoader";
import RecipeList from "./RecipeList";

const SEARCH_QUERY = loader("../queries/search.graphql");

export default function SearchList() {
	const { q } = useParams();

	const { loading, error, data } = useQuery(SEARCH_QUERY, {
		variables: { query: q },
		skip: !q,
	});

	if (loading) {
		return (
			<div className="section">
				<SearchLoader />
			</div>
		);
	}

	if (error) {
		return "Error";
	}

	const recipes = data?.search?.hits?.map((el) => el._source) || [];

	return (
		<div className="section">
			<h1 className="is-size-3">
				Search Results for Query{" "}
				<strong>
					<i>{q}</i>
				</strong>
			</h1>
			<RecipeList recipes={recipes} type="list" />
		</div>
	);
}
